import { HTTPClient } from "@abaco/web-common/src/HTTP";
import { dbGIStoStandardPage } from "@abaco/web-common/src/Paging";
import { ServiceOrigineAzienda } from "../farm-registry/models/Custom";

const RPP = 25;

export default class CustomApi {

    private http: HTTPClient;

    constructor(http: HTTPClient) {
        this.http = http;
    }

    async serviceOrigineAzienda(cuaa: string): Promise<ServiceOrigineAzienda[]> {
        const res = await this.http.get("/siticatasto/dbgis-servlet/rest_tl_data", {
            params: {
                svccode: "portal/serviceOrigineAzienda",
                //svccode: "portal/serviceOrigineAziendaFakeFinded",
                //svccode: "portal/serviceOrigineAziendaFakeNotFinded",
                cuaa: cuaa
            }
        });

        const ret = dbGIStoStandardPage<ServiceOrigineAzienda>(res.data, RPP).records;
        return ret;
    }

}
